module.exports = "https://cdn.thelire.com/ins/resource/lh_app_vip_40.79dcb3f5d5f9f23dd76ef82dd8af0010.png";